module.exports = "/static/assets/7d4fa08c40e2fac41e67fb4f143535d0.gif";